<template>
    <template v-if="loading">
        <Loading />
    </template>

    <template v-else-if="errorMessage" class="error-message">
        <p>{{ errorMessage }}</p>
    </template>

    <a
        v-else-if="events[0]?.event.booking?.bookingLinkURL"
        :href="events[0].event.booking?.bookingLinkURL"
        class="book-button btn book-button--custom"
    >
        {{ defaultButtonTitle }}
    </a>

    <a
        v-else-if="events.length === 1"
        :href="events[0].ctaPrimary.link"
        class="book-button btn book-button--single"
    >
        {{ events[0].ctaPrimary.title || defaultButtonTitle }}
    </a>

    <template v-else-if="events.length">
        <button
            class="book-button btn book-button--multiple"
            @click="performanceListDialogRef?.open()"
        >
            {{ defaultButtonTitle }}
        </button>

        <Dialog ref="performanceListDialogRef" class="performance-popup">
            <div class="performance-popup__header">
                <h2 class="performance-popup__title">Choose a Performance</h2>
            </div>
            <div
                v-if="props.description"
                class="performance-popup__description s-prose"
                v-html="props.description"
            ></div>
            <PerformanceList :eventId="props.eventId" />
        </Dialog>
    </template>
</template>

<script setup>
import { computed, onBeforeMount, ref } from 'vue';
import { getPerformances } from '../../services/inventory';
import PerformanceList from './PerformanceList.vue';
import Dialog from '../Dialog/Dialog.vue';

const props = defineProps({
    eventId: {
        type: String,
        required: true,
    },
    description: {
        type: String,
        default: '',
    }
});

const defaultButtonTitle = computed(() => {
    return events.value[0].event.theme.settings.primaryBtn.title || 'Get Tickets';
});

const events = ref([]);
const loading = ref(true);
const performanceListDialogRef = ref(null);
const errorMessage = ref(null);

onBeforeMount(async () => {
    try {
        events.value = await getPerformances()
            .then(perfs => perfs.filter(perf => perf.event.id === props.eventId));
    } catch (error) {
        console.error(error);
        errorMessage.value = 'Something has gone wrong, please try again later.';
        events.value = [];
    } finally {
        loading.value = false;
    }
});
</script>
